module.exports = __webpack_public_path__ + "static/media/washington-dc-9.ea9d4df3.jpg";